import * as types from '@store/types'

const state = {
  routes: [],
  names: {
    '': 'Início'
  },
}

const getters = {
  [types.BREADCRUMB]: (state) => {
    const toCrumbs = ([route, ...routes]) => {
      if (!route) return []

      const name = state.names[route.path] || null

      if (!name) return toCrumbs(routes)

      const crumb = route.link.name
        ? { name, link: route.link }
        : { name, link: { path: '/' } }

      return [ crumb, ...toCrumbs(routes) ]
    }

    return toCrumbs(state.routes)
  },
}

const mutations = {
  [types.BREADCRUMB_NAMES]: (state, names) => {
    state.names = { ...state.names, ...names }
  },

  [types.BREADCRUMB_ROUTES]: (state, routes) => {
    state.routes = routes
  },
}

const actions = {
  [types.BREADCRUMB_NAMES]: ({ commit }, names) => commit(types.BREADCRUMB_NAMES, names),

  [types.BREADCRUMB_ROUTES]: ({ commit }, to) => {
    const { query, params } = to

    const routes = (to.matched || []).map(
      ({ name, path }) => ({
        path,
        link: { params, name, query },
      })
    )

    commit(types.BREADCRUMB_ROUTES, routes)
  },
}

export default { state, getters, mutations, actions }




// WEBPACK FOOTER //
// ./src/store/modules/breadcrumb.js